module.exports = __webpack_public_path__ + "img/invoiceSetAct.80c70021.png";